import React from 'react'

const IconWarningTriangle = props => {
  const width = props.width || props.size
  const height = props.height || props.size

  return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 24 24' fill={props.color} xmlns="http://www.w3.org/2000/svg"
        >   <path d="M11.0036 14.2509H13.0036L13.0036 8.25085H11.0036L11.0036 14.2509Z" fill={props.color} />
            <path d="M12.0036 15.7509C11.3132 15.7509 10.7536 16.3105 10.7536 17.0009C10.7536 17.6912 11.3132 18.2509 12.0036 18.2509C12.6939 18.2509 13.2536 17.6912 13.2536 17.0009C13.2536 16.3105 12.6939 15.7509 12.0036 15.7509Z" fill={props.color} />
            <path fillRule="evenodd" clipRule="evenodd" d="M1.11523 20.5351L11.1152 1.53511H12.8851L22.8851 20.5351L22.0002 22.0009H2.00015L1.11523 20.5351ZM3.65652 20.0009H20.3438L12.0002 4.14795L3.65652 20.0009Z" fill={props.color} />
        </svg>

  )
}

IconWarningTriangle.defaultProps = {
  color: 'currentcolor',
  size: '1em'
}

export default IconWarningTriangle
